import { api } from '@/api/client'
import {
  fetchIncidentContext,
  fetchIncidentKinds,
  patchIncidentStatus,
  todayMsk,
  type BarcodeStatItem,
  type IncidentKindOption,
  type IncidentStatus,
  type PosIncident,
  type PosIncidentContextEvent,
} from '@/features/cash/posIncidentsApi'

export type {
  BarcodeStatItem,
  IncidentKindOption,
  IncidentStatus,
  PosIncident,
  PosIncidentContextEvent,
}
export { fetchIncidentContext, fetchIncidentKinds, patchIncidentStatus, todayMsk }

export interface StoreIncidentSummary {
  day: string
  store_id: number
  total: number
  new: number
  confirmed: number
  rejected: number
  by_terminal: Array<{
    terminal_id: number
    num: number | null
    new: number
    total: number
  }>
  by_kind: Array<{ kind: string; label: string; count: number }>
}

export async function fetchStorePosIncidents(
  storeId: string | number,
  opts?: {
    day?: string
    kind?: string
    status?: IncidentStatus | 'all'
    text?: string
    terminalId?: number
    limit?: number
  },
): Promise<{ day: string; store_id: number; incidents: PosIncident[] }> {
  const q = new URLSearchParams()
  q.set('day', opts?.day || todayMsk())
  if (opts?.kind) q.set('kind', opts.kind)
  if (opts?.status && opts.status !== 'all') q.set('status', opts.status)
  if (opts?.text) q.set('text', opts.text)
  if (opts?.terminalId) q.set('terminalId', String(opts.terminalId))
  if (opts?.limit) q.set('limit', String(opts.limit))
  return api(`/api/trassir/stores/${storeId}/pos-incidents?${q}`)
}

export async function fetchStoreIncidentsSummary(
  storeId: string | number,
  opts?: { day?: string },
): Promise<StoreIncidentSummary> {
  const q = new URLSearchParams()
  q.set('day', opts?.day || todayMsk())
  return api(`/api/trassir/stores/${storeId}/pos-incidents/summary?${q}`)
}

export async function fetchStoreBarcodeStats(
  storeId: string | number,
  opts?: { day?: string; terminalId?: number; limit?: number },
): Promise<{ day: string; items: BarcodeStatItem[] }> {
  const q = new URLSearchParams()
  q.set('day', opts?.day || todayMsk())
  if (opts?.terminalId) q.set('terminalId', String(opts.terminalId))
  if (opts?.limit) q.set('limit', String(opts.limit))
  return api(`/api/trassir/stores/${storeId}/pos-incidents/barcode-stats?${q}`)
}
